import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { hide } from 'store/modules/modal';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  error: {
    margin: 10,
  },
});

export const PackageErrorsDialog = ({
  classes,
  opened,
  metadata,
  dispatch,
}) => {
  return (
    <div>
      <Dialog open={opened} onClose={() => dispatch(hide())}>
        <DialogTitle>Package detailed feedback</DialogTitle>
        <DialogContent>
          <div className={classes.error}>
            <Typography variant="body1" color="primary">
              File name
            </Typography>
            <Typography color="textSecondary">{metadata.filename}</Typography>
          </div>
          <div className={classes.error}>
            <Typography variant="body1" color="primary">
              Selector
            </Typography>
            <Typography color="textSecondary">{metadata.selector}</Typography>
          </div>
          <div className={classes.error}>
            <Typography variant="body1" color="primary">
              Context
            </Typography>
            <Typography color="textSecondary">{metadata.context}</Typography>
          </div>
          <div className={classes.error}>
            <Typography variant="body1" color="primary">
              Code
            </Typography>
            <Typography color="textSecondary">{metadata.code}</Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => dispatch(hide())} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    opened: state.modal.opened,
    message: ownProps.message,
  };
};

export default withStyles(styles)(
  connect(mapStateToProps)(PackageErrorsDialog)
);
